<template>
<div class='slide slide-video--activity slide-video-activity'>
  <div class='slide_label body-four-light'>
    {{ activity.subheadline }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div class='slide_subheadline body-one-light'>
    {{ activity.instructions }}
  </div>

  <a
    href='#watch-video-activity'
    role='button'
    class='slide_cta button-one-light'
    @click.prevent='initModalVideo'
  >
     {{ activity.cta }}
  </a>

  <sweet-modal
    ref='modalVideo'
    modal-theme='dark'
    overlay-theme='dark'
    :hide-close-button='true'
    @close='closeModalVideo'
  >
    <div
      class='slide-video-activity_modal-restricter'
      tabindex='0'
      @focus='returnToClose'
    />

    <button
      ref='video-close'
      class='modal-video_close'
      @click='$refs.modalVideo.close()'
    >
      {{ $t('close') }}
      <CloseIcon />
    </button>

    <h1 class='slide-video-activity_modal-title'>
      {{ activity.headline }}
    </h1>

    <div class='slide-video-activity_modal-video' />

    <div
      class='slide-video-activity_modal-restricter'
      tabindex='0'
      @focus='returnToClose'
    />
  </sweet-modal>
</div>
</template>

<script>
import CommonMixin from './common-mixin'
import { SweetModal } from 'sweet-modal-vue-3'
import TbkVideo from 'tbk-utils/video/tbk-video'
import CloseIcon from '../icons/close-gray.svg'

export default {
  mixins: [CommonMixin],

  components: {
    SweetModal,
    CloseIcon
  },

  methods: {
    initModalVideo() {
      this.getEmbedCode()
      this.$refs.modalVideo.open()
      // $('.part-contents').addClass('modal-video-opened')

      // Autoplay video
      if (this.activity.provider === 'wistia') {
        const vid = {}
        vid[this.activity.code.substr(0, 3)] = function(video) {
          video.play()
        }
        _wq.push(vid)
      }

      setTimeout(() => {
        this.$refs['video-close'].focus()
      }, 1)
    },

    becameHidden() {
      this.vClient && this.vClient.pause($(this.$el).find('.slide-video-activity_modal-video')[0])
      this.$refs.modalVideo.close()
    },

    getEmbedCode() {
      this.vClient = TbkVideo.new(this.activity.provider, this.activity.code)

      this.vClient.getEmbedCode(function(code, video) {
        if (this.activity.provider === 'wistia') {
          this.loadWistiaPlugins(video, this.activity.complete_threshold)
        }

        $(this.$el).find('.slide-video-activity_modal-video').html(code)
      }.bind(this))
    },

    closeModalVideo() {
      $(this.$el).find('.slide-video-activity_modal-video').html('')
      // $('.part-contents').removeClass('modal-video-opened')
    },

    loadWistiaPlugins(video, percent_complete) {
      this.initWistiaCaptions()
      this.vClient.loadCrossTime(percent_complete, this.onComplete)
    },

    onComplete(video) {
      this.updateResult('watched')
    },

    initWistiaCaptions() {
      if (this.locale !== 'en') {
        this.vClient.loadCaptions(this.locale)
      }
    },

    returnToClose() {
      this.$refs['video-close'].focus()
    }

  }

}
</script>

<style lang='sass' scoped>
@import './video-with-instructions-v1'
</style>
